import { useSelector } from "react-redux";
import { selectUserRoles } from "../redux/slices/userSlice";
import { isPermissionPresent } from "../utilities/generalUtility";

export const usePermission = () => {
  const roles = useSelector(selectUserRoles);

  const hasAccess = (permissions, allowSuperAdmin = true) =>
    isPermissionPresent(permissions, roles, allowSuperAdmin);

  return { hasAccess };
};
